<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="modal-container" @click.stop>
                    <!-- Header -->
                    <div class="modal-header-custom d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <button
                                type="button"
                                class="back-btn mr-2"
                                @click="$emit('closeModal')"
                                aria-label="Kembali"
                            >
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.5 11L1 6M1 6L5.5 1M1 6H15" stroke="#111827" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <h5 class="modal-title-custom mb-0">Pengembalian QR ke Dealer</h5>
                        </div>
                        <button type="button" class="btn btn-close-custom" @click="$emit('closeModal')">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body-custom">
                        <!-- Jumlah QR -->
                        <div class="modal-form-row">
                            <label class="modal-form-label mb-0">Jumlah QR</label>
                            <div class="modal-form-input">
                                <input
                                    type="text"
                                    class="form-control custom-input-qty"
                                    placeholder="0"
                                    v-model="form.qty"
                                    :class="{'is-invalid': qtyError}"
                                />
                                <span v-if="qtyError" class="field-error-text">{{ qtyError }}</span>
                            </div>
                        </div>

                        <!-- Tanda Tangan -->
                        <div class="modal-form-row align-top">
                            <label class="modal-form-label mb-0 pt-1">Tanda Tangan</label>
                            <div class="modal-form-input">
                                <div class="signature-box" :class="{'signature-box--error': signatureError}">
                                    <vue-signature-pad width="100%" height="118px" ref="signaturePad" :options="{ onBegin: clearSignatureError }" />
                                    <button
                                        type="button"
                                        class="btn-clear-signature"
                                        @click="$refs.signaturePad.clearSignature()"
                                    >
                                        Hapus
                                    </button>
                                </div>
                                <span v-if="signatureError" class="field-error-text">{{ signatureError }}</span>
                            </div>
                        </div>

                        <!-- Actions -->
                        <div class="modal-actions-row d-flex justify-content-end align-items-center">
                            <button
                                type="button"
                                class="btn btn-batal"
                                @click="$emit('closeModal')"
                            >
                                Batal
                            </button>
                            <button
                                type="button"
                                class="btn btn-kirim"
                                @click="submitReturn"
                            >
                                Kirim
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data () {
            return {
                saldoQr: 0,
                dealerTujuan: null,
                qtyError: '',
                signatureError: '',
                form: {
                    qty: '',
                    sender_signature: null,
                },
            }
        },
        computed: {
            maxQty() {
                return Math.max(0, this.saldoQr);
            },
            qtyExceedsMax() {
                return Number(this.form.qty) > this.maxQty;
            },
            dealerTujuanLabel() {
                return this.dealerTujuan ? `${this.dealerTujuan.code} - ${this.dealerTujuan.name}` : 'Dealer Induk';
            },
        },
        watch: {
            'form.qty'() {
                this.qtyError = '';
            },
        },
        mounted () {
            this.loadSaldo();
            this.loadDealerTujuan();
        },
        methods: {
            numberWithCommas(x) {
                if (!x && x !== 0) return '0';
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            },
            async loadSaldo() {
                try {
                    let response = await this.$http.get('/api/qrs/highlight/dealer/saldo');
                    if (response && response.data && response.data.data && response.data.data.qty_after !== undefined) {
                        this.saldoQr = response.data.data.qty_after;
                    }
                }
                catch (err) {
                    console.log(err);
                }
            },
            async loadDealerTujuan() {
                try {
                    let response = await this.$http.get('/api/qrs/return/parent');
                    if (response && response.data && response.data.data) {
                        this.dealerTujuan = response.data.data;
                    }
                }
                catch (err) {
                    console.log(err);
                }
            },
            clearSignatureError() {
                this.signatureError = '';
            },
            async submitReturn() {
                try {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                    this.qtyError = '';
                    this.signatureError = '';

                    if (this.form.qty === '' || isNaN(Number(this.form.qty)) || Number(this.form.qty) === 0) {
                        this.qtyError = 'Jumlah QR wajib diisi';
                    } else if (this.qtyExceedsMax) {
                        this.qtyError = `Maksimal pengembalian ${this.numberWithCommas(this.maxQty)} QR`;
                    }

                    if (isEmpty) {
                        this.signatureError = 'Silahkan lengkapi tanda tangan Anda';
                    }

                    if (this.qtyError || this.signatureError) {
                        return;
                    }

                    const confirmResult = await this.$swal.fire({
                        html: `
                                <div class="swal-confirm-header">
                                    <span class="swal-confirm-title">Pengembalian QR ke Dealer</span>
                                </div>
                                <div class="swal-confirm-content">
                                    <div class="swal-confirm-icon">
                                        <svg width="124" height="112" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 59.0101 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                                        </svg>
                                    </div>

                                    <div class="swal-confirm-text">
                                        Anda akan mengembalikan <strong>${this.form.qty}</strong> QR ke
                                        <br>
                                        <strong>${this.dealerTujuanLabel}</strong>
                                        <br>
                                        <br>
                                        Apa anda yakin jumlahnya sudah benar?
                                    </div>
                                </div>
                            `,
                        showCancelButton: true,
                        showCloseButton: true,
                        confirmButtonText: "Ya, Proses",
                        cancelButtonText: "Batal",
                        reverseButtons: true,
                        customClass: {
                            popup: 'swal2-popup-confirm',
                            cancelButton: 'swal-btn-cancel',
                            confirmButton: 'swal-btn-confirm',
                        }
                    });

                    const isConfirmed = confirmResult && (confirmResult.isConfirmed || confirmResult.value === true);
                    if (!isConfirmed) return;

                    const payload = {
                        qty: Number(this.form.qty),
                        sender_signature: data.split(",")[1]
                    };

                    await this.$http.post('/api/qrs/return/create', payload);

                    await new Promise((resolve) => setTimeout(resolve, 200));

                    await this.$swal.fire({
                        html: `
                            <div class="swal-success-content">
                                <div class="swal-success-icon">
                                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M35.75 0C28.6793 0 21.7674 2.0967 15.8884 6.02496C10.0093 9.95322 5.42716 15.5366 2.72132 22.0691C0.0154899 28.6015 -0.692479 35.7897 0.686942 42.7245C2.06636 49.6593 5.47122 56.0293 10.4709 61.0291C15.4707 66.0288 21.8407 69.4336 28.7755 70.8131C35.7104 72.1925 42.8985 71.4845 49.4309 68.7787C55.9634 66.0729 61.5468 61.4907 65.4751 55.6116C69.4033 49.7326 71.5 42.8207 71.5 35.75C71.49 26.2716 67.7203 17.1842 61.018 10.482C54.3158 3.77973 45.2284 0.0100094 35.75 0ZM51.4456 29.4456L32.1956 48.6956C31.9402 48.9513 31.6369 49.1541 31.3031 49.2925C30.9693 49.4309 30.6114 49.5022 30.25 49.5022C29.8886 49.5022 29.5308 49.4309 29.1969 49.2925C28.8631 49.1541 28.5598 48.9513 28.3044 48.6956L20.0544 40.4456C19.5384 39.9296 19.2485 39.2298 19.2485 38.5C19.2485 37.7702 19.5384 37.0704 20.0544 36.5544C20.5704 36.0384 21.2703 35.7485 22 35.7485C22.7298 35.7485 23.4296 36.0384 23.9456 36.5544L30.25 42.8622L47.5544 25.5544C47.8099 25.2989 48.1132 25.0962 48.4471 24.9579C48.7809 24.8196 49.1387 24.7485 49.5 24.7485C49.8614 24.7485 50.2192 24.8196 50.553 24.9579C50.8868 25.0962 51.1901 25.2989 51.4456 25.5544C51.7011 25.8099 51.9038 26.1132 52.0421 26.447C52.1804 26.7809 52.2515 27.1387 52.2515 27.5C52.2515 27.8613 52.1804 28.2191 52.0421 28.553C51.9038 28.8868 51.7011 29.1901 51.4456 29.4456Z" fill="#2FBF56"/>
                                    </svg>
                                </div>
                                <div class="swal-success-text">
                                    Pengembalian QR Berhasil
                                </div>
                            </div>
                        `,
                        confirmButtonText: "Tutup",
                        customClass: {
                            popup: 'swal2-popup-success',
                            confirmButton: 'swal-btn-success-confirm'
                        }
                    });

                    this.$emit('updateTable');
                    this.$emit('closeModal');
                }
                catch (err) {
                    console.log(err);
                    this.$swal.fire({
                        title: "Error",
                        text: (err && err.message) ? err.message : "Gagal mengajukan pengembalian",
                        icon: "error",
                    });
                }
            },
        }
    }
</script>

<style>
    .swal2-popup-confirm .swal-btn-cancel {
        color: #F36F21 !important;
    }
    .swal2-popup-confirm .swal-btn-confirm {
        background: #F36F21 !important;
        color: #ffffff !important;
        border: 1px solid #F36F21 !important;
    }
    .swal2-popup-confirm .swal2-actions {
        width: 100%;
    }
    .swal2-popup-confirm .swal2-actions button {
        min-width: 150px !important;
        font-size: 12px !important;
    }
    .swal2-popup-confirm .swal-confirm-icon {
        margin-bottom: 12px;
        margin-top: 8px;
        display: flex;
        justify-content: center;
        overflow: visible;
    }

    .swal2-popup-confirm .swal-confirm-icon svg {
        display: block;
        overflow: visible;
    }

    .swal2-popup-confirm .swal-confirm-text {
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #000000 !important;
        line-height: normal !important;
        text-align: center !important;
    }
    .swal2-popup-success .swal-success-icon {
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
    }
    .swal2-popup-success {
        width: 360px !important;
        padding: 24px !important;
    }
    .swal2-popup-success .swal-success-text {
        font-size: 16px !important;
        font-weight: 600 !important;
        color: #000000 !important;
        line-height: normal !important;
        text-align: center !important;
    }

    .swal2-popup-success .swal2-actions {
        width: 100%;
        justify-content: center !important;
    }

    .swal2-popup-success .swal-btn-success-confirm {
        background: #F36F21 !important;
        color: #ffffff !important;
        border: 1px solid #F36F21 !important;
        width: 150px !important;
        min-width: 150px !important;
        font-size: 12px !important;
    }
    .swal2-popup-confirm {
        width: 401px !important;
        padding-top: 16px !important;
        font-family: 'Inter', sans-serif !important;
    }

    .swal2-popup-confirm .swal-confirm-header {
        min-height: 24px;
        margin-top: 0;
        text-align: left;
        font-size: 12px;
        color: #000000;
        font-weight: 600;
    }
    .swal2-popup-confirm .swal2-close {
        color: #000000 !important;
        font-size: 20px !important;
        width: 24px !important;
        height: 24px !important;
        top: 8px !important;
        right: 13px !important;
    }
</style>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1060;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.3s ease;
        padding: 20px;
    }

    .modal-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-container {
        width: 521px;
        max-width: 521px;
        min-height: 357px;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        padding: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }

    .modal-header-custom {
        height: 48px;
        padding: 12px 20px;
        border-bottom: 1px solid #F3F4F6;
        flex-shrink: 0;
        box-sizing: border-box;
    }

    .back-btn {
        background: transparent;
        border: none;
        padding: 0;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        outline: none;
        line-height: 1;
    }

    .modal-title-custom {
        font-size: 15px;
        font-weight: 600;
        color: #111827;
    }

    .btn-close-custom {
        padding: 0;
        border: none;
        background: transparent;
        color: #111827;
        font-size: 16px;
        cursor: pointer;
        line-height: 1;
        outline: none;
        box-shadow: none;
    }

    .btn-close-custom:hover {
        color: #6B7280;
    }

    .modal-body-custom {
        padding: 24px 20px 20px 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
    }

    .modal-form-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .modal-form-row.align-top {
        align-items: flex-start;
        margin-bottom: 24px;
    }

    .modal-form-label {
        width: 112px;
        min-width: 112px;
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 600;
        color: #2F2F2F;
    }

    .modal-form-input {
        flex: 1;
        min-width: 0;
    }

    .custom-input-qty {
        height: 36px;
        border: 1px solid #E5E7EB;
        border-radius: 4px;
        font-size: 13px;
        color: #2F2F2F;
        padding: 6px 12px;
        box-shadow: none;
    }

    .custom-input-qty:focus {
        border-color: #F36F21;
        box-shadow: none;
    }

    .signature-box {
        border: 1px solid #E5E7EB;
        border-radius: 4px;
        position: relative;
        background: #FFFFFF;
        overflow: hidden;
        height: 136px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .signature-box--error {
        border-color: #DC2626 !important;
    }

    .signature-box canvas {
        display: block;
    }

    .btn-clear-signature {
        position: absolute;
        bottom: 8px;
        right: 12px;
        background: transparent;
        border: none;
        color: #ADADAD;
        font-size: 13px;
        cursor: pointer;
        padding: 0;
        outline: none;
        line-height: 1;
    }

    .btn-clear-signature:hover {
        color: #6B7280;
    }

    .field-error-text {
        display: block;
        text-align: left;
        font-size: 11px;
        color: #DC2626;
        margin-top: 4px;
    }

    .modal-actions-row {
        margin-top: 8px;
    }

    .btn-batal {
        background: transparent;
        border: none;
        color: #F36F21;
        font-size: 14px;
        font-weight: 500;
        padding: 0;
        margin-right: 20px;
        box-shadow: none;
        cursor: pointer;
        outline: none;
        line-height: 1;
    }

    .btn-batal:hover {
        color: #D95D16;
    }

    .btn-kirim {
        background-color: #F36F21;
        border: 1px solid #F36F21;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        width: 104px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: none;
        cursor: pointer;
        outline: none;
        line-height: 1;
        transition: background-color 0.2s, border-color 0.2s;
    }

    .btn-kirim:hover:not(:disabled) {
        background-color: #D95D16;
        border-color: #D95D16;
        color: #FFFFFF;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
    }
</style>
